import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, ModuleFE_Thunderstorm, stopPropagation } from '@nu-art/thunderstorm-frontend';
import './Component_SearchMeta.scss';
import { __stringify, filterInstances, formatTimestamp } from '@nu-art/ts-common';
import { ModuleFE_CSVParser } from '@nu-art/thunderstorm-frontend/modules/ModuleFE_CSVParser';
export class Component_SearchMeta extends ComponentSync {
    //######################### Life Cycle #########################
    __onSearchResultsChanged = () => {
        this.forceUpdate();
    };
    componentDidMount() {
        this.props.context.searchResultChangeListeners.register(this);
    }
    componentWillUnmount() {
        this.props.context.searchResultChangeListeners.unregister(this);
    }
    //######################### Logic #########################
    printResults = (e) => {
        if (!e.metaKey)
            return;
        stopPropagation(e);
        this.logInfo('SearchResults', this.props.context.getSearchResults());
    };
    exportResults = (e) => {
        const results = this.props.context.getSearchResults();
        if (!results?.length)
            return;
        stopPropagation(e);
        const searchItemMap = this.props.context.getActiveSearchItems().reduce((map, searchItem) => {
            map[searchItem.module.dbDef.dbKey] = searchItem;
            return map;
        }, {});
        //Map results csv ready objects
        const objects = filterInstances(results.map(result => {
            const searchItem = searchItemMap[result.dbKey];
            if (!searchItem)
                return;
            return {
                collection: result.dbKey,
                id: result.id,
                label: searchItem.labelResolver(result),
                item: __stringify(result),
            };
        }));
        const str = ModuleFE_CSVParser.toString(objects);
        const fileName = `Search Results - [${formatTimestamp('DD/MM/YYYY-HH:mm:ss')}]`;
        ModuleFE_Thunderstorm.downloadFile({
            fileName,
            content: str,
            mimeType: 'text/csv',
        });
    };
    //######################### Render #########################
    render() {
        const searchResults = this.props.context.getSearchResults();
        if (!searchResults?.length)
            return;
        return _jsxs(LL_H_C, { className: 'c__search-meta', onClick: this.printResults, children: [_jsxs("div", { className: 'c__search-meta__results', onClick: this.exportResults, children: [searchResults.length, " Results"] }), this.renderTime()] });
    }
    renderTime = () => {
        const searchTime = this.props.context.getSearchTime();
        if (!searchTime)
            return;
        const str = searchTime >= 1000 ? `${searchTime / 1000}s` : `${searchTime}ms`;
        return _jsx("div", { className: 'c__search-meta__time', children: str });
    };
}
//# sourceMappingURL=Component_SearchMeta.js.map